import 'jquery-validation';
import Utils from '../../util/utils';
const CareerForm = {
    _jForm: $('.jsContactForm'),

    init() {
        this.initValidations();
        this.addEvents();
    },
    initValidations() {
        const me = this;
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    name: {
                        required: true,
                        minlength: 3,
                    },
                    email: {
                        required: true,
                        customemail: true,
                        emailNotBanned: true,
                    },

                },
                messages: {
                    name: {
                        required: 'Please provide your Name',
                        minlength: 'Please provide your complete Name',
                    },
                    email: {
                        required: 'Please provide your E-mail address',
                        customemail: 'Please provide a valid E-mail address',
                    },
                },
                submitHandler: function () {
                    me.onFormSubmit();
                },
            });

            this._jForm.validate(config);
        }
    },
    addEvents() {

        document.addEventListener( 'wpcf7submit', function( event ) {

          if ( '5213' == event.detail.contactFormId) {
              $('.jsCareerUploadFilename').text('Upload Your Resume*');
          }
        }, false );
    },
    onFormSubmit() {
        if (this._jForm.valid()) {

            // var $form = this._jForm;
            // var unindexed_array = $form.serializeArray();
            // var indexed_array = {};
            // jQuery.map(unindexed_array, function (n) {
            //     indexed_array[n['name']] = n['value'];
            // });
            // var formData = {};

           var formData = new FormData(document.getElementById('CareerForm'));



            Utils.sendRequest({
                'url': '/wp-admin/admin-ajax.php',
                'data': {
                    'action': 'submitCareerForm',
                    'formData': formData,
                },
                'skipLoader': true,
                'onDone': $.proxy(this._onSuccess, this),
            });
        }
        return false;
    },
    _onSuccess(response) {
        this._jForm[0].reset();
        Utils.showLoader(false);
        // $('.jsCareerUploadFilename').text('Upload Your Resume');
        Utils.notify({
            'message': response.message,
        });
    },
}
export default CareerForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/career-form.js